<template>
    <div>
        <!-- 基本信息 -->
        <div class="inputList" v-if="isBasic">
            <labelInput :outInput="newform.company_name" :spanRequired="true" normalPlace="请输入企业名称"
                        @inputChange="labelInput($event,'company_name')"
                        spanTitle="企业名称" :spanWidth="spanWidth" componentWidth="90%">
            </labelInput>

            <p class="view_head midflex">申报联系人</p>
            <labelInput :outInput="newform.contacts_name" :spanRequired="true" normalPlace="请输入姓名"
                        @inputChange="labelInput($event,'contacts_name')"
                        spanTitle="姓名" :spanWidth="spanWidth" componentWidth="520px">
            </labelInput>

            <labelInput :outInput="newform.contacts_post" :spanRequired="true" normalPlace="职务"
                        @inputChange="labelInput($event,'contacts_post')"
                        spanTitle="职务" :spanWidth="spanWidth" componentWidth="520px">
            </labelInput>

            <labelInput :outInput="newform.contacts_phone" :spanRequired="true" normalPlace="请输入联系电话"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="电话" :spanWidth="spanWidth" componentWidth="520px"
                        >
            </labelInput>

            <labelInput :outInput="newform.cellphone" :spanRequired="true" normalPlace="请输入手机"
                        @inputChange="labelInput($event,'cellphone')"
                        spanTitle="手机" :spanWidth="spanWidth" componentWidth="520px" :isPhone="true" specilType='number'
                        :maxLimit="11">
            </labelInput>


            <!-- 主要经营管理指标统计 -->
            <p class="view_head midflex">企业经济指标</p>

            <labelInput :outInput="newform.liability_ratio" :spanRequired="true" specilType='number' normalPlace="请输入资产负债率"
                        @inputChange="labelInput($event,'liability_ratio')" spanTitle="资产负债率(%)" :spanWidth="spanWidth"
                        componentWidth="90%"   :maxLimit="2">
            </labelInput>
            <labelInput :outInput="newform.profit_rate" :spanRequired="true" specilType='number' normalPlace="请输入产值利润率"
                        @inputChange="labelInput($event,'profit_rate')" spanTitle="产值利润率(%)" :spanWidth="spanWidth"
                        componentWidth="90%" :maxLimit="2">
            </labelInput>
            <labelInput  :outInput="newform.growth_rate" :spanRequired="true" specilType='number' normalPlace="请输入净资产增长率"
                         @inputChange="labelInput($event,'growth_rate')" spanTitle="净资产增长率(%)" :spanWidth="spanWidth"
                         componentWidth="90%" :maxLimit="2">
            </labelInput>

        </div>

        <!-- 获奖信息 -->
        <div class="awardInfo" v-else>

            <div style="display: flex;align-items: center;justify-content: flex-start;width: 100%;flex-wrap: wrap;"
                 v-for="(items,indexs) in oldAddList">

                <labelText spanTitle="资质类别" :spanWidth="spanWidth" componentWidth="520px"
                           :pContent="items.qualification_category"></labelText>

                <labelText spanTitle="等级" :spanWidth="spanWidth" componentWidth="520px"
                           :pContent="items.qualification_level"></labelText>

                <labelText spanTitle="证书编号" :spanWidth="spanWidth" componentWidth="520px"
                           :pContent="items.certificate_no"></labelText>

                <labelText spanTitle="有效期" :spanWidth="spanWidth" componentWidth="520px"
                           :pContent="items.effective_time"></labelText>

                <div>
                    <el-button style="width: 70px;height: 40px;margin-left: 10px;"
                               @click="deleteList(indexs,'1')">删
                    </el-button>
                </div>

            </div>



            <div style="display: flex;align-items: center;flex-wrap: wrap;border-bottom: 1px solid #f0f2f5 " v-for="(item,index) in addList"
                 :key="index">

                <labelInput :outInput="item.qualification_category" :spanRequired="true" normalPlace="请填写"
                            @inputChange="typeThreeInput($event,'1',index)" :spanTitle="'资质类别'+(index+1)" spanWidth="180px"
                            componentWidth="500px">
                </labelInput>

                <labelInput :outInput="item.qualification_level" :spanRequired="true" normalPlace="请填写"
                            @inputChange="typeThreeInput($event,'2',index)" spanTitle="等级" spanWidth="180px"
                            componentWidth="500px">
                </labelInput>

                <labelInput :outInput="item.certificate_no" :spanRequired="true" normalPlace="请填写"
                            @inputChange="typeThreeInput($event,'3',index)" spanTitle="证书编号" spanWidth="180px"
                            componentWidth="500px">
                </labelInput>

                <normalPicker :outInput="item.effective_time" :spanRequired="true" pelaceHolder="请输入日期"
                              spanTitle="有效期" :spanWidth="spanWidth"
                              @selectDate="typeThreeInput($event,'4',index)" componentWidth="520px">
                </normalPicker>

                <div>
                    <el-button style="width: 70px;height: 40px;margin-left: 10px;"
                               @click="deleteList(index)">删
                    </el-button>
                </div>

            </div>

            <!-- 按钮 -->
            <div class="newAddBtn" style="margin: 10px 10px;margin-left: 90%">
                <el-button type="primary" @click="addInstall">增行</el-button>
            </div>

            <div class="uploadBtn" style="margin: auto">
                <el-button type="primary" @click="getWinninginfo">保存</el-button>
            </div>

        </div>
    </div>
</template>

<script>
    import labelInput from '../../../components/table/labelInput.vue'
    import normalPicker from '../../../components/table/normalPicker.vue'

    import {

        getWinningInfo

    } from '../../../api/moudles/manager.js'

    import {
        API_DOMAIN
    } from '../../../api/api.js'


    import {saveQua, setBasicProgram} from "../../../api/moudles/manager";
    import labelText from '../../../components/table/labelText.vue'

    export default {
        data() {
            return {

                spanWidth: '180px',
                newform:{
                    company_name: '',
                    contacts_name: '',
                    contacts_post: '',
                    contacts_phone: '',
                    cellphone: '',
                    liability_ratio: '',
                    profit_rate: '',
                    growth_rate: '',
                },
                addList:[],

                oldAddList: [],

                form: {
                    company_name: '',
                    contacts_name: '',
                    contacts_post: '',
                    contacts_phone: '',
                    cellphone: '',
                    liability_ratio: '',
                    profit_rate: '',
                    growth_rate: '',
                },
            }
        },
        components: {
            labelInput,
            normalPicker,
            labelText,
        },
        props: {
            // 切换基本信息和获奖信息
            isBasic: {
                type: Boolean,
                default: true
            },
            project_app_num: {
                type: String,
                default: ''
            },

            basicMsg: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            awardMsg: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        watch: {
            basicMsg(newvalue) {
                this.newform = {
                    ...newvalue
                }
            },

            awardMsg(newvalue) {

                console.log(4444)
                console.log(newvalue)
                console.log(8888)

                this.oldAddList = newvalue
            }
        },
        created() {
            if (this.isBasic) {
                this.$emit('basicInfo', this.form)
            }
        },
        methods: {


            // 提交获奖信息
            async getWinninginfo() {

                const params = {
                    ...this.levelOne
                }

                if (this.project_app_num) {
                    params.project_app_num = this.project_app_num
                }

                let newAddList = [...this.addList, ...this.oldAddList]
                for (let item in newAddList) {
                    if (!newAddList[item].qualification_category || !newAddList[item].qualification_level) {
                        this.$message.error('未填写完整')
                        return
                    }
                }

                params.awardJson = newAddList

                await saveQua({
                    data: params,
                    success: res => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            //this.project_app_num = res.data.project_app_num
                        } else {
                           // this.project_app_num = res.data.project_app_num
                            this.$message.error(res.msg)
                        }
                    }
                })

            },


            // 新增参建单位输入
            typeThreeInput(e, type, index) {
                if (type == '1') {
                    this.addList[index].qualification_category = e
                } else if(type == '2'){
                    this.addList[index].qualification_level = e
                }else if(type == '3'){
                    this.addList[index].certificate_no = e
                }else{
                    this.addList[index].effective_time = e
                }
            },
            // 新增参建单位
            addInstall() {
                this.addList.push({})
            },
            // 删除行
            deleteList(index, type) {
                const number = this.addList.length + this.oldAddList.length
                if (number === 1) {
                    this.$message.error(`至少填写一条参建信息`)
                    return
                }
                if (type === '1') {
                    // 例旧信息
                    this.oldAddList.splice(index, 1)
                } else {
                    this.addList.splice(index, 1)
                }

            },

            labelInput(e, name) {
                this.form[name] = e
                this.$emit('basicInfo', this.form)
            },
            labelInput2(e, name, id) {
                const params = [id, name, e]
                this.$emit('awardInfo', params)
            }
        }
    }
</script>

<style scoped>
    .midflex {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
    }

    .inputList {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .view_head {
        font-size: 18px;
        font-weight: 600;
        margin-top: 20px;
    }

    .titleLeft {
        margin-left: 50px;
    }

    .awardInfo {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    /* 提示 */
    .allTips {
        margin: 20px 0;
        padding-left: 80px;
        text-align: left;
    }

    .tipList {
        /* margin-left: 80px; */
        display: flex;
        justify-content: flex-start;
    }

    .tipList p {
        display: inline-block;
        text-align: left;
        line-height: 25px;
    }

    .tipList p:nth-child(1) {
        width: 80px;
    }

    .tipList p:nth-child(2) {
        width: 200px;
    }

    .tipList p:nth-child(3) {
        width: 350px;
    }
</style>
